// Core React
import React from "react";
import PropTypes from "prop-types";

// Utility Libraries
import classNames from "classnames";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

// Assets
import CloseIcon from "../../../../assets/icons/close.svg";

// Bootstrap components
import Modal from "react-bootstrap/Modal";

// Material-UI components
import Accordion from "@material-ui/core/Accordion";

// Custom components
import ApprovalLevel from "./ApprovalLevel/ApprovalLevel";
import UpdateWarning from "./UpdateWarning/UpdateWarning";
import UserSearchView from "./UserSearchView/UserSearchView";
import ManageApprovalFooter from "./ManageApprovalFooter/ManageApprovalFooter";

// Constants
import { ADD_LEVEL, UPDATE_ALL_LEVELS } from "../../CreateNewFolder";

// Styles
import "./ManageApprovalModal.scss";

function ManageApprovalModal({
  isOpen = false,
  onCloseHandler = () => console.log("No onclose handler provided"),
  mutationHandler = () => console.log("No Mutation handler provided"),
  approvalLevels = [],
  isEditApprovalMode = false,
  accessUsers = [],
  isLoading = false,
}) {
  const onDragEndHandler = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const updatedApprovalLevels = reorder(
      approvalLevels,
      result.source.index,
      result.destination.index
    );
    mutationHandler(UPDATE_ALL_LEVELS, updatedApprovalLevels);
  };
  const isSubmitBtnDisabled = approvalLevels.every(
    (approvalLevel) => approvalLevel.levelName === ""
  );

  return (
    <Modal
      show={isOpen}
      dialogClassName={`${"manage-approval-modal"}`}
      centered
      onHide={() => 24}
    >
      <Modal.Header>
        <h4 className="modal-title">
          {isEditApprovalMode ? "Edit Approval Levels" : "Add Approval Levels"}
        </h4>
        <img
          className="close"
          src={CloseIcon}
          alt="closeIcon"
          onClick={() => onCloseHandler()}
        />
      </Modal.Header>
      <Modal.Body>
        <div
          className={classNames({
            "manage-approval-modal-edit-body": isEditApprovalMode,
            "manage-approval-modal-create-body": !isEditApprovalMode,
          })}
        >
          {isEditApprovalMode && <UpdateWarning />}

          <DragDropContext onDragEnd={onDragEndHandler}>
            <Droppable droppableId="approvalLevels">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {approvalLevels.map((approvalLevel, index) => {
                    return (
                      <Draggable
                        key={approvalLevel.id}
                        draggableId={approvalLevel.id}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                            }}
                          >
                            <Accordion square className="mb-4">
                              <ApprovalLevel
                                approvalLevel={approvalLevel}
                                mutationHandler={mutationHandler}
                                index={index}
                              />
                              <UserSearchView
                                approvalLevel={approvalLevel}
                                mutationHandler={mutationHandler}
                                accessUsers={accessUsers}
                              />
                            </Accordion>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <button
          className="btn-secondary btn-block mt-5"
          onClick={() => mutationHandler(ADD_LEVEL)}
        >
          Add Another
        </button>
      </Modal.Body>
      <Modal.Footer>
        <ManageApprovalFooter
          onCloseHandler={onCloseHandler}
          isEditApprovalMode={isEditApprovalMode}
          isSubmitBtnDisabled={isSubmitBtnDisabled}
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
}

ManageApprovalModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  mutationHandler: PropTypes.func,
  approvalLevels: PropTypes.array,
  isEditApprovalMode: PropTypes.bool,
  accessUsers: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};
export default ManageApprovalModal;

// Util functions

function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result.map((u, index) => ({
    ...u,
    order: index + 1,
  }));
}
